import { createReducer } from '@reduxjs/toolkit';

import { loadProvidersMerchantsSuccess, loadProvidersStart, loadProvidersSuccess } from './actions';
import { IProviderListData, IProvidersReducer } from './types';

const initialState: IProvidersReducer = {
  isLoading: false,
  isLoaded: false,
  data: {} as IProviderListData,
  merchantAccounts: {} as IProviderListData,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loadProvidersStart, (state) => ({ ...state, isLoading: true }))
    .addCase(loadProvidersSuccess, (state, action) => ({ ...state, isLoading: false, isLoaded: true, data: action.payload }))
    .addCase(loadProvidersMerchantsSuccess, (state, action) => ({
      ...state,
      isLoading: false,
      isLoaded: true,
      merchantAccounts: action.payload,
    }));
});
